import './style.sass';
import UndoIcon from './editorImages/arrow-u-left-top.svg';
import RedoIcon from './editorImages/arrow-u-right-bottom.svg';
import FormatAlignCenter from './editorImages/format-align-center.svg';
import FormatAlignLeft from './editorImages/format-align-left.svg';
import FormatAlignRight from './editorImages/format-align-right.svg';
import FormatBold from './editorImages/format-bold.svg';
import FormatItalic from './editorImages/format-italic.svg';
import FormatListBulleted from './editorImages/format-list-bulleted.svg';
import FormatListNumbered from './editorImages/format-list-numbered.svg';
import FormatUnderline from './editorImages/format-underline.svg';
import LinkIcon from './editorImages/link-variant.svg';
import styles from './styles.module.sass';

/**
 * The toolbar groups this app is allowed to enable.
 *
 * Deliberately excludes 'embedded', which renders react-draft-wysiwyg's
 * Embedded button — the sink for GHSA-fq5x-7292-2p5r (XSS). That advisory has
 * no published fix (1.15.0 is the package's final release) and is accepted in
 * pnpm-workspace.yaml's `audit.ignore` on the grounds that the button is not
 * reachable in our UI. Widening this union breaks that argument, so it fails
 * `tsc` instead. See MAT-2020 for the migration that retires the package.
 */
type AuditedToolbarOption =
  | 'inline'
  | 'list'
  | 'textAlign'
  | 'link'
  | 'history';

const editorToolbarConfig = {
  options: [
    'inline',
    'list',
    'textAlign',
    'link',
    'history',
  ] satisfies AuditedToolbarOption[],
  inline: {
    inDropdown: false,
    className: styles['EditorToolbarItem'],
    options: ['bold', 'italic', 'underline'],
    bold: {
      icon: FormatBold,
      className: styles['EditorToolbarIcon'],
    },
    italic: { icon: FormatItalic, className: styles['EditorToolbarIcon'] },
    underline: {
      icon: FormatUnderline,
      className: styles['EditorToolbarIcon'],
    },
  },
  list: {
    inDropdown: false,
    className: styles['EditorToolbarItem'],
    options: ['unordered', 'ordered'],
    unordered: {
      icon: FormatListBulleted,
      className: styles['EditorToolbarIcon'],
    },
    ordered: {
      icon: FormatListNumbered,
      className: styles['EditorToolbarIcon'],
    },
  },
  textAlign: {
    inDropdown: false,
    className: styles['EditorToolbarItem'],
    options: ['left', 'center', 'right'],
    left: { icon: FormatAlignLeft, className: styles['EditorToolbarIcon'] },
    center: { icon: FormatAlignCenter, className: styles['EditorToolbarIcon'] },
    right: { icon: FormatAlignRight, className: styles['EditorToolbarIcon'] },
  },
  link: {
    inDropdown: false,
    className: styles['EditorToolbarItem'],
    popupClassName: styles['EditorLinkPopup'],
    showOpenOptionOnHover: false,
    defaultTargetOption: '_self',
    options: ['link'],
    link: { icon: LinkIcon, className: styles['EditorToolbarIcon'] },
  },
  history: {
    inDropdown: false,
    className: styles['EditorToolbarItem'],
    options: ['undo', 'redo'],
    undo: { icon: UndoIcon, className: styles['EditorToolbarIcon'] },
    redo: { icon: RedoIcon, className: styles['EditorToolbarIcon'] },
  },
};

export default editorToolbarConfig;
